import {convertStringToNumber} from "@/scripts/Common/helpers/numberHelpers";

const saveItemToStorage = (item: number | string, key: string) => {
  try {
    if(typeof item === 'string'){
      window.localStorage.setItem(key, item);
      return;
    }
    window.localStorage.setItem(key, item.toString(10));
  } catch (e) {}
}

const getNumberItemFromStorage = (key: string) => {
  try {
    return convertStringToNumber(window.localStorage.getItem(key) ?? '');
  } catch (e) {
    return 0;
  }
}

const getStringItemFromStorage = (key: string) => {
  try {
    return window.localStorage.getItem(key) ?? ''
  } catch (e) {
    return '';
  }
}

const removeItemFormStroage = (key: string) => {
  try {
    window.localStorage.removeItem(key);
  }
  catch (e){}
}

const clearStorage = () => {
  try{
    window.localStorage.clear()
  }
  catch (e){}
}

export {
  saveItemToStorage,
  getNumberItemFromStorage,
  getStringItemFromStorage,
  removeItemFormStroage,
  clearStorage
}
